import axios from "axios";

const state = {}
const mutations = {}
const getters = {}
const actions = {
    getDistrictRMP(context, params) {
            return new Promise((resolve, reject) => {
                axios.get(`pdm/${params}`, {params: params})
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
    },
    fetchDistrict(context, params) {
            return new Promise((resolve, reject) => {
                axios.get(`pdm-district`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}
